export enum JobAlertsQueryKey {
  List = 'job-alerts-list',
}

export const PENDING_SAVE_STORAGE_KEY = 'jobAlerts:pendingSave';
